import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { logoutUser } from '../actions/authentication';
import { navigateToBatches, navigateToLogin } from '../actions/router';
import { getAuth } from '../actions/authentication.localStorage';
import { getCulture } from '../actions/culture';
import { requestWidgetUrl } from '../actions/widget';
import { withBackgroundHeightAdjust } from '../components/WithBackgroundHeightAdjust';
import Widget from '../components/Widget';

const mapStateToProps = (state, { match }) => {
    var authentication = getAuth();

    return {
        culture: getCulture(state),
        username: authentication ? authentication.name : null,
        url: state.widget.url,
        groupName: state.widget.groupName
    };
};

const mapDispatchToProps = (dispatch, {history}) => {
    return {
        onLogout: function() {
            dispatch(logoutUser()).then(navigateToLogin(history));
        },
        onBack: function() {
            navigateToBatches(history);
        },
        onMount: function() {
            dispatch(requestWidgetUrl()).then((result) => {
                if (!result.success) {
                    dispatch(logoutUser()).then(navigateToLogin(history));
                }
            });
        }
    };
};

const WidgetContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withBackgroundHeightAdjust(Widget)));

export default WidgetContainer;
